// The organization a person was in last, for `/` after sign-in. It is a convenience of this browser: the slug sits in
// localStorage, which can be empty or refuse access (private windows), so every read and write is guarded and the app
// works without it (it then picks the first membership).
const KEY = 'orca.lastOrg'

export function rememberOrg(slug: string): void {
  try {
    localStorage.setItem(KEY, slug)
  } catch {
    // no storage: nothing to remember
  }
}

function remembered(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

/** Where `/` sends a signed-in person: the last organization still among their memberships, else the first, else `/welcome`. */
export function landingFor(memberships: { slug: string; status?: string }[]): { slug: string } | null {
  const usable = memberships.filter((m) => m.status === undefined || m.status === 'active')
  const last = remembered()
  return usable.find((m) => m.slug === last) ?? usable[0] ?? null
}
